#@import Booking.Presenters.Picker
#@export Booking.Presenters.OptionPicker

class Booking.Presenters.OptionPicker extends Booking.Presenters.Picker

  selected: ->
    @model.getSelectedOption()

  toHash: ->
    hash = Booking.Presenters.Picker::toHash.apply(this, arguments)

    selectedOption = @selected()

    if selectedOption?
      hash.selectedOption =
        title: selectedOption.getTitle()

    hash
